import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'autopredict-new',
  templateUrl: './autopredict-new.component.html',
  styleUrls: ['./autopredict-new.component.scss']
})
export class AutopredictNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
